import { defineFcm } from '../shared/factory';

export const FCM_STARTER_EXPERIENCE_READY_TO_SHARE_PREDRAFTED_PROMPT = defineFcm(
	'starter_experience_ready_to_share_predrafted_prompt',
)
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-axolotl',
		scope: 'llm-service',
		context: 'Starter Dashboard',
		description: 'Gates whether the ready-to-share prompts run in the LLM prompt executor',
	});
